<template>
  <div>
    <e-btn :loading="isLoading" icon size="S" variant="ghost">
      <e-icon name="copy" :size="20" class="cursor-pointer" @click="copy" />
    </e-btn>
    <e-tooltip v-model="showTooltip" :open-on-hover="false" :timeout="2000" :z-index="999999" location="right">
      <div v-if="result" class="d-flex align-center text-secondary">
        <e-icon name="check" class="text-green" />
        <span class="ml-1"> Скопировано в буфер обмена </span>
      </div>
      <div v-else class="d-flex align-center text-secondary">
        <e-icon name="block" class="text-red" />
        <span class="ml-1"> Не удалось скопировать в буфер обмена </span>
      </div>
    </e-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { EBtn, EIcon, ETooltip } from '@/core/components/ui';
import { copyToClipboard } from '@/core/utils/copy-to-clipboard';

const props = defineProps<{
  text: string;
}>();

const isLoading = ref(false);

const result = ref(false);
const showTooltip = ref(false);

const copy = async () => {
  isLoading.value = true;

  result.value = await copyToClipboard(props.text);

  showTooltip.value = true;

  isLoading.value = false;
};
</script>

<style scoped lang="scss"></style>
